'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'flux-capacitor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ba';
var svgPathData = ['M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16zm32 72c0-30.9 25.1-56 56-56s56 25.1 56 56c0 6.6-1.1 12.9-3.2 18.8l35.2 35.2 35.2-35.2c-2.1-5.9-3.2-12.2-3.2-18.8 0-30.9 25.1-56 56-56s56 25.1 56 56-25.1 56-56 56c-6.6 0-12.9-1.1-18.8-3.2l-45.2 45.2 0 27.4c18.9 9 32 28.3 32 50.6 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6l0-27.4-45.2-45.2c-5.9 2.1-12.2 3.2-18.8 3.2-30.9 0-56-25.1-56-56z', 'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm90.8 188.8l45.2 45.2 0 27.4c-18.9 9-32 28.3-32 50.6 0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-27.4 45.2-45.2c5.9 2.1 12.2 3.2 18.8 3.2 30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56c0 6.6 1.1 12.9 3.2 18.8l-35.2 35.2-35.2-35.2c2.1-5.9 3.2-12.2 3.2-18.8 0-30.9-25.1-56-56-56s-56 25.1-56 56 25.1 56 56 56c6.6 0 12.9-1.1 18.8-3.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFluxCapacitor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;